import React from 'react'
import styled from '@emotion/styled'
import { useProfileImage } from '../hooks/useProfileImage'

const AvatarCircle = styled.div<{ size: number }>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 50%;
  background: var(--portal-primary, #7c3aed);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #ffffff;
  overflow: hidden;
  flex-shrink: 0;
  font-size: ${({ size }) => Math.max(12, Math.round(size * 0.4))}px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

type ProfileAvatarProps = {
  profileImagePath?: string | null
  fallbackLetter: string
  size?: number
  className?: string
}

export const ProfileAvatar: React.FC<ProfileAvatarProps> = ({
  profileImagePath,
  fallbackLetter,
  size = 32,
  className
}) => {
  const { objectUrl } = useProfileImage(profileImagePath)

  return (
    <AvatarCircle size={size} className={className} aria-hidden={!objectUrl}>
      {objectUrl ? <img src={objectUrl} alt="" /> : fallbackLetter}
    </AvatarCircle>
  )
}
